export const PATHS_MAP = {
  '/things': {
    role: 'client',
    title: 'Случай клиента'
  }
};
